const mobileNav = document.querySelector('.sidenav');
const mobileNavBtn = document.querySelector('.m-nav-btn');
const closeMobileNavBtn = document.querySelector('.mobile-nav-close');
const tabbables = mobileNav.querySelectorAll('a[tabindex]');
let currentWidth = window.innerWidth;
const threshold = 769;

/*
  set tabindex for screens < 769
 */
if (currentWidth < threshold) {
  mobileNavBtn.tabIndex = 0;
};

tabbables.forEach((a) => {
  const submenu = a.nextElementSibling;
  if (submenu?.nodeName === 'UL') {
    a.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') _flipTabIndex(submenu);
    })
    a.addEventListener('click', e => _flipTabIndex(submenu));
  };
});

/*
  detect when screen passes 768
 */
window.onresize = () => {
  if (_viewChanged(window.innerWidth, currentWidth, threshold)) {
    mobileNavBtn.tabIndex = _flip(mobileNavBtn.tabIndex);
  };

  currentWidth = window.innerWidth;
};

function _viewChanged (nextWidth, currentWidth, threshold) {
  const resizedToMobile = nextWidth < threshold && currentWidth >= threshold;
  const resizedToDesktop = nextWidth >= threshold && currentWidth < threshold;
  return resizedToMobile || resizedToDesktop;
};

/*
  open mobile nav button
 */
mobileNavBtn.addEventListener('keyup', function(e) {
  if (e.key === 'Enter') {_openMobileNav()}
});
mobileNavBtn.addEventListener('click', _openMobileNav);

function _openMobileNav () {
  mobileNav.classList.add("mobile-nav-open");
  _flipTabIndex(mobileNav, 'dropdown-menu');
  return false;
};

/*
  close mobile nav button
 */
closeMobileNavBtn.addEventListener('click', _closeMobileNav);

function _closeMobileNav () {
  mobileNav.classList.remove("mobile-nav-open");
  const openDropdowns = mobileNav.querySelectorAll(".open")
  openDropdowns.forEach(dropdown => _toggleDropdown(dropdown.firstElementChild));
  _flipTabIndex(mobileNav, '_', -1);
  return false;
};

/*
  open close dropdown
 */
mobileNav.querySelectorAll('.m-nav .dropdown > a').forEach(function(v, i) {
    v.addEventListener('click', e => _toggleDropdown(e.target))
});

function _toggleDropdown (target) {
  const p = target.parentElement, n = target.nextElementSibling;
  p.classList.toggle('open');

  if (p.classList.contains('open'))
    n.style.height = n.scrollHeight + 'px';
  else
    n.style.height = 0;
};

/*
  General helpers
 */
function _flipTabIndex (node, exception='', override=null) {
  node.querySelectorAll('a[tabindex]').forEach((a) => {
    if (typeof(override) === 'number') {
      a.tabIndex = override;
      return;
    }
    if (exception && a.parentNode.parentNode.classList.contains(exception)) return;

    const lastIndex = a.tabIndex;
    a.tabIndex = _flip(lastIndex);
  })
};

function _flip (n) {
  return n * -1 - 1;
};
